// the css is injected automatically
// require('!style-loader!css-loader!postcss-loader!stylus-loader!./pagebreak.styl');

var hasErrorPage = false;
var hasThankYouPage = false;
var hasLoginPage = false;


function parse(text, next) {
    var parseRe = /(\/{3}\/*)(\#{1}[A-Za-z0-9\-]+)?/gi,
        pageNumber = 1,
        matchExists = false,
        match;

    // find all pagebreaks, insert html between pages
    while (match = parseRe.exec(text)) {
        var id = (match[2]) ? ' id="' + match[2].replace("#", "") + '"' : '';

        if (match[2] == '#error') {
            this.hasErrorPage = true;
        }
        else if (match[2] == '#thank-you') {
            this.hasThankYouPage = true;
        }
        else if (match[2] == '#login') {
            this.hasLoginPage = true;
        }

        text = text.replace(match[0], "</div><div class=\"page page-" + (++pageNumber) + "\"" + id + ">");
        matchExists = true;
    }

    // wrap the first and last page
    if (matchExists) {
        text = "<div class=\"page page-1 currentpage\">" + text + "</div>";
    }

    next(text);

};

function init(formRoot, meta, next) {
    var pages = formRoot.querySelectorAll('.page');

    var btnBack = formRoot.querySelector('.backlink-box');

    var submitPage = null;

    for (page in pages) {
        if (!pages[page].getAttribute) {
            continue;
        }

        var id = pages[page].getAttribute("id");

        if (id != "error" && id != "thank-you" && id != "login") {
            if (submitPage != null) {
                submitPage.insertAdjacentHTML("beforeend", "<div class=\"button-box\"><a class=\"mbgf-form-button page-next\">Nästa</a></div>");

                if (btnBack) {
                    submitPage.insertAdjacentHTML("beforeend", btnBack.cloneNode(true).outerHTML.toString());
                }
            }
            submitPage = pages[page];
        }
        else {
            if (btnBack) {
                pages[page].insertAdjacentHTML("beforeend", btnBack.cloneNode(true).outerHTML.toString());
            }
        }
    }


    if (submitPage != null) {
        if (formRoot.querySelector(".submit-box")) {
            submitPage.appendChild(formRoot.querySelector(".submit-box"));

            if (btnBack) {
                submitPage.insertAdjacentHTML("beforeend", btnBack.cloneNode(true).outerHTML.toString());
            }
        }
    }

    if (pages.length && btnBack) {
        btnBack.style.display = "none";
    }

    var nextButtons = formRoot.querySelectorAll(".page-next");

    if (nextButtons.length > 0) {
        for (nextButton in nextButtons) {
            if (nextButtons[nextButton].addEventListener) {
                nextButtons[nextButton].addEventListener("click", function (e) {
                    var current = formRoot.getElementsByClassName("currentpage")[0];
                    current.className = current.className.replace("currentpage", "");
                    var next = current.nextSibling;

                    while (next.getAttribute("id") == "error" || next.getAttribute("id") == "thank-you") {
                        next = next.nextSibling;
                    }

                    next.className = next.className + " currentpage";
                });
            }
        }
    }

    next(formRoot);
}

module.exports = {
    parse: parse,
    init: init,
    hasErrorPage: hasErrorPage,
    hasThankYouPage: hasThankYouPage,
    hasLoginPage: hasLoginPage
};



// WEBPACK FOOTER //
// ./js-src/markdown-editor/modules/pagebreak/pagebreak.js